var $ = global.jQuery = global.$;

var widgets = require('../lib/widgets');
var parser = require('../lib/parser');

var _Base = require('./_Base');

/**
 * Gallery item widget
 * @class
 * @extends _Base
 */
var GalleryItem = _Base.extend(
  /** @lends GalleryItem.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.gallery = widgets.getWidget('galleryOverlay');

    this.item = {};

    this.item.Video = this.$el.data('video');

    // Check if it's a data-image or the simplified data-image-large and normalise the item.Image object
    if (this.$el.data('image')) {
      this.item.Image = this.$el.data('image');
    } else if(this.$el.data('imageLarge')) {
      this.item.Image = {
        Src: this.$el.data('imageLarge')
      };
    }

    this.item.Caption = this.$el.data('caption');

    if (this.gallery) {
      this.index = this.gallery.addItem(this.item);
    } else {
      this.createGallery();
    }

    this.$el.on('click', function(event) {
      event.preventDefault();
      self.gallery.open(self.index);
    });

  },
  /**
   * Create gallery (if one doesn't already exist)
   */
  createGallery: function() {
    var self = this;
    var tmpl = require('templates/galleryOverlay.dot');
    $('body').append(tmpl());
    parser.parseOne($('#galleryOverlay'), function() {
      self.gallery = widgets.getWidget('galleryOverlay');
      self.index = self.gallery.addItem(self.item);
    });
  },
  /**
   * Fires on removal of gallery item
   */
  onRemove: function() {
    this.gallery.removeItem(this.index);
  }
});

module.exports = GalleryItem;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/GalleryItem.js
// module id = 236
// module chunks = 0 1